import Client from 'config/axios';

export const disableCompany = async (token: string, id: any) => {
  const body = {};
  const { data } = await Client.post(`company/disable/${id}`, body, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return {
    data
  };
};
